import Api from '../api';

const MetadataService = {
  async getMetaData(key: string) {
    return Api.get(`/metadata/${key}`);
  },
  async getMetaDatas(keys: string[]) {
    return Api.get(`/metadata?keys=${keys.join(',')}`);
  },
};

export default MetadataService;
